var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiMapPinOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9091 9.78755C20.9091 16.3633 12.4545 21.9997 12.4545 21.9997C12.4545 21.9997 4 16.3633 4 9.78755C4 7.54527 4.89074 5.39482 6.47628 3.80929C8.06181 2.22375 10.2123 1.33301 12.4545 1.33301C14.6968 1.33301 16.8473 2.22375 18.4328 3.80929C20.0183 5.39482 20.9091 7.54527 20.9091 9.78755Z",
    stroke: "#FF7971",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4547 12.6061C14.0111 12.6061 15.2728 11.3443 15.2728 9.78791C15.2728 8.23147 14.0111 6.96973 12.4547 6.96973C10.8982 6.96973 9.63647 8.23147 9.63647 9.78791C9.63647 11.3443 10.8982 12.6061 12.4547 12.6061Z",
    stroke: "#FF7971",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiMapPinOrange);
export default __webpack_public_path__ + "static/media/fi_map-pin-orange.e2c86202492e1b1623ac9568bacfb57d.svg";
export { ForwardRef as ReactComponent };